import { call, put, takeLatest } from "redux-saga/effects";

import {
SAVE_PORTAL_REGISTRATION} from "./actionType";

import { savePortalRegistrationSuccess, portalRegistrationError} from "./action";

import {India_Portal_Registration_API, } from "../../../helpers/backend_helper";


// SAVE
function* savePortalRegistrationSaga({ config }) {
  try {
    const response = yield call(India_Portal_Registration_API, config);
    yield put(savePortalRegistrationSuccess(response));
  } catch (error) {
    yield put(portalRegistrationError());
  }
}

// ROOT
function* PortalRegistrationSaga() {
  yield takeLatest(SAVE_PORTAL_REGISTRATION, savePortalRegistrationSaga);
}

export default PortalRegistrationSaga;